import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getName } from "country-list";
import ReactCountryFlag from "react-country-flag";
import { Skeleton } from "primereact/skeleton";
import { fetchEntityDetail } from "~/components/global-entities/globalEntitiesSlice";
import Layout from "~/Layout";
import "../officers-attorny.scss";

const OfficersAttornyLayout = ({ children, type }) => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const entityData = useSelector((state) => state.globalEntities.entity_detail);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await dispatch(fetchEntityDetail(id));
      setLoading(false);
    };

    fetchData();
  }, [dispatch, id]);
  return (
    <Layout
      crumbs={[
        {
          label: (
            <Link to="/entities" className="link__style">
              My Entities
            </Link>
          ),
          id: "entities",
        },
        {
          label: (
            <Link to={`/entity/${id}/dashboard`} className="link__style flex">
              {!loading ? (
                entityData?.name
              ) : (
                <Skeleton width="100px" height="20px" className="mr-1" />
              )}
              {!loading ? (
                " "
              ) : (
                <Skeleton width="10px" height="20px" className="mr-1" />
              )}
              {!loading ? (
                <>
                  (
                  <ReactCountryFlag
                    countryCode={entityData?.country || ""}
                    svg
                    className=""
                  />{" "}
                  {getName(entityData?.country || "")})
                </>
              ) : (
                <Skeleton width="150px" height="20px" className="mr-1" />
              )}
            </Link>
          ),
          id: "entity",
        },
        {
          label: type === "officer" ? "Officer Registry" : "Attorney Registry",
          id: "officer-attorny-power",
        },
      ]}
    >
      {children}
    </Layout>
  );
};
export default OfficersAttornyLayout;
